export default "__VITE_ASSET__CX0w7j4K__"